import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPosts,
  getTop10Posts,
  getTheLatestPosts,
  getFBPosts,
  getTWPosts,
  getNWPosts,
  getIGPosts,
  addNewPost,
  updatePost,
  deletePost,
  getStatsPosts,
  getTotalStatsPosts,
  getTotalLikesCounts,
  getTotalStatsQueryPosts,
  getStatsFBPosts,
  getStatsTWPosts,
  getStatsNWPosts,
  getStatsIGPosts,
  getRPTStatsPosts,
  getRPTStatsBySource,
  getRPTTotalStatsPosts,
  getRPTPosts,
  getWordCloud,
  getMonthlyTrend,
  getPlatformPosts,
} from "./thunk";
import { readThunkError } from "../thunkError";

export const initialState = {
  top10posts: [],
  thelatestposts: [],
  totalstatsposts: [],
  rpttotalstatsposts: [],
  totalstatsQueryposts: [],
  totallikescounts: [],

  allposts: [],
  posts: [],
  fbposts: [],
  twposts: [],
  nwposts: [],
  igposts: [],
  rptposts: [],

  statsposts: [],
  rptstatsposts: [],
  statsFBposts: [],
  statsTWposts: [],
  statsNWposts: [],
  statsIGposts: [],

  // Эх сурвалж бүрийн тайлангийн статистик: { facebook: [...], threads: [...] }
  rptstatsBySource: {},
  wordcloud: [],
  monthlyTrend: [],

  allerror: {},
  top10error: {},
  thelatesterror: {},
  fberror: {},
  twerror: {},
  nwerror: {},
  igerror: {},
  rpterror: {},
  statserror: {},
  totalstatserror: {},
  rptstatserror: {},
  rptstatsBySourceError: {},
  rpttotalstatserror: {},
  totalstatsQueryerror: {},
  totallikescountserror: {},
  wordclouderror: {},

  statFBserror: {},
  statTWserror: {},
  statNWserror: {},
  statIGserror: {},

  top10postsLoading: {},
  thelatestpostsLoading: {},
  rptpostsLoading: {},
  fbpostsLoading: {},
  twpostsLoading: {},
  nwpostsLoading: {},
  igpostsLoading: {},
  statspostsLoading: {},
  rptstatspostsLoading: {},
  rpttotalstatspostsLoading: [],

  isStatsPostLoading: false,
  isStatsPostSuccess: false,

  isTotalStatsPostSuccess: false,
  isTotalStatsPostLoading: false,

  isTotalTotalLikesCountsSuccess: false,
  isTotalTotalLikesCountsLoading: false,

  isTop10PostSuccess: false,
  isTop10PostLoading: false,

  isTheLatestPostSuccess: false,
  isTheLatestPostLoading: false,

  isFBPostLoading: false,
  isFBPostSuccess: false,

  isTWPostLoading: false,
  isTWPostSuccess: false,

  isNWPostLoading: false,
  isNWPostSuccess: false,

  isIGPostLoading: false,
  isIGPostSuccess: false,

  isTotalStatsQueryPostLoading: false,
  isTotalStatsQueryPostSuccess: false,

  isAllPostLoading: false,
  isAllPostSuccess: false,

  isWordCloudLoading: false,
  isWordCloudSuccess: false,

  // Getter-ээр нэмэгдсэн платформууд: { threads: [], youtube: [], linkedin: [] }
  platformPosts: {},
  platformPostsLoading: {},
};

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getALLPosts/ ]=================================
    builder.addCase(getAllPosts.pending, (state) => {
      state.isAllPostLoading = true;
      state.isAllPostSuccess = false;
      state.allerror = null;
    });
    builder.addCase(getAllPosts.fulfilled, (state, action) => {
      state.isAllPostLoading = false;
      state.isAllPostSuccess = true;
      state.allposts = action.payload;
    });
    builder.addCase(getAllPosts.rejected, (state, action) => {
      state.isAllPostLoading = false;
      state.isAllPostSuccess = false;
      state.allerror = readThunkError(action);
    });
    //====================================================================================

    //The latest posts
    builder.addCase(getTheLatestPosts.pending, (state) => {
      state.isTheLatestPostLoading = true;
    });

    builder.addCase(getTheLatestPosts.fulfilled, (state, action) => {
      state.thelatestposts = action.payload;
      state.isTheLatestPostFail = false;
      state.isTheLatestPostSuccess = true;
      state.isTheLatestPostLoading = false;
    });

    builder.addCase(getTheLatestPosts.rejected, (state, action) => {
      state.thelatesterror = readThunkError(action);
      state.isTheLatestPostFail = true;
      state.isTheLatestPostSuccess = false;
      state.isTheLatestPostLoading = false;
    });

    // Getter-ээр нэмэгдсэн платформууд (threads / youtube / linkedin)
    builder.addCase(getPlatformPosts.pending, (state, action) => {
      const p = action.meta.arg && action.meta.arg.platform;
      if (p) state.platformPostsLoading[p] = true;
    });
    builder.addCase(getPlatformPosts.fulfilled, (state, action) => {
      const { platform, posts, page } = action.payload || {};
      if (!platform) return;
      const incoming = Array.isArray(posts) ? posts : [];
      // ⚠️ 1-р хуудас (эсвэл шүүлт шинэчлэгдэх) бол сольж бичнэ; 2+ бол
      // өмнөх мөрүүдийн ард НЭМНЭ — эс бол доош гүйлгэхэд зөвхөн сүүлийн
      // хуудасны мэдээлэл л үлдэж, өмнөх постууд алга болдог байв.
      if (Number(page) > 1) {
        const prev = state.platformPosts[platform] || [];
        const newIds = new Set(incoming.map((p) => p._id));
        state.platformPosts[platform] = [...prev.filter((p) => !newIds.has(p._id)), ...incoming];
      } else {
        state.platformPosts[platform] = incoming;
      }
      state.platformPostsLoading[platform] = false;
    });
    builder.addCase(getPlatformPosts.rejected, (state, action) => {
      const p = action.meta.arg && action.meta.arg.platform;
      if (p) state.platformPostsLoading[p] = false;
      state.error = readThunkError(action);
    });

    //==================================[ /Top posts/ ]=======================================
    builder.addCase(getTop10Posts.pending, (state) => {
      state.isTop10PostLoading = true;
      state.isTop10PostSuccess = false;
      state.top10error = null;
    });
    builder.addCase(getTop10Posts.fulfilled, (state, action) => {
      state.isTop10PostLoading = false;
      state.isTop10PostSuccess = true;
      state.top10posts = action.payload;
    });
    builder.addCase(getTop10Posts.rejected, (state, action) => {
      state.isTop10PostLoading = false;
      state.isTop10PostSuccess = false;
      state.top10error = readThunkError(action);
    });

    //==================================[ /statstotal/ ]=======================================
    builder.addCase(getTotalStatsPosts.pending, (state) => {
      state.isTotalStatsPostLoading = true;
      state.isTotalStatsPostSuccess = false;
      state.totalstatserror = null;
    });
    builder.addCase(getTotalStatsPosts.fulfilled, (state, action) => {
      state.isTotalStatsPostLoading = false;
      state.isTotalStatsPostSuccess = true;
      state.totalstatsposts = action.payload;
    });
    builder.addCase(getTotalStatsPosts.rejected, (state, action) => {
      state.isTotalStatsPostLoading = false;
      state.isTotalStatsPostSuccess = false;
      state.totalstatserror = readThunkError(action);
    });
    //====================================================================================

    //==================================[ /total likes count/ ]==========================
    builder.addCase(getTotalLikesCounts.pending, (state) => {
      state.isTotalTotalLikesCountsLoading = true;
      state.isTotalTotalLikesCountsSuccess = false;
      state.totallikescountserror = null;
    });
    builder.addCase(getTotalLikesCounts.fulfilled, (state, action) => {
      state.isTotalTotalLikesCountsLoading = false;
      state.isTotalTotalLikesCountsSuccess = true;
      state.totallikescounts = action.payload;
    });
    builder.addCase(getTotalLikesCounts.rejected, (state, action) => {
      state.isTotalTotalLikesCountsLoading = false;
      state.isTotalTotalLikesCountsSuccess = false;
      state.totallikescountserror = readThunkError(action);
    });
    //====================================================================================

    //total report
    builder.addCase(getRPTTotalStatsPosts.fulfilled, (state, action) => {
      state.rpttotalstatsposts = action.payload;
      state.isRPTTotalStatsPostFail = false;
      state.isRPTTotalStatsPostSuccess = true;
    });

    builder.addCase(getRPTTotalStatsPosts.rejected, (state, action) => {
      state.rpttotalstatserror = readThunkError(action);
      state.isRPTTotalStatsPostFail = true;
      state.isRPTTotalStatsPostSuccess = false;
    });

    //==================================[ /total Query count/ ]==========================
    builder.addCase(getTotalStatsQueryPosts.pending, (state) => {
      state.isTotalStatsQueryPostLoading = true;
      state.isTotalStatsQueryPostSuccess = false;
      state.totalstatsQueryerror = null;
    });
    builder.addCase(getTotalStatsQueryPosts.fulfilled, (state, action) => {
      state.isTotalStatsQueryPostLoading = false;
      state.isTotalStatsQueryPostSuccess = true;
      state.totalstatsQueryposts = action.payload;
    });
    builder.addCase(getTotalStatsQueryPosts.rejected, (state, action) => {
      state.isTotalStatsQueryPostLoading = false;
      state.isTotalStatsQueryPostSuccess = false;
      state.totalstatsQueryerror = readThunkError(action);
    });
    //====================================================================================

    //facebook
    builder.addCase(getStatsFBPosts.fulfilled, (state, action) => {
      state.statsFBposts = action.payload;
      state.isStatsFBPostFail = false;
      state.isStatsFBPostSuccess = true;
      state.fbpostsLoading = false;
    });

    builder.addCase(getStatsFBPosts.rejected, (state, action) => {
      state.statFBserror = readThunkError(action);
      state.isStatsFBPostFail = true;
      state.isStatsFBPostSuccess = false;
      state.fbpostsLoading = false;
    });

    //twitter
    builder.addCase(getStatsTWPosts.fulfilled, (state, action) => {
      state.statsTWposts = action.payload;
      state.isStatsTWPostFail = false;
      state.isStatsTWPostSuccess = true;
      state.twpostsLoading = false;
    });

    builder.addCase(getStatsTWPosts.rejected, (state, action) => {
      state.statTWserror = readThunkError(action);
      state.isStatsTWPostFail = true;
      state.isStatsTWPostSuccess = false;
      state.twpostsLoading = false;
    });

    //news
    builder.addCase(getStatsNWPosts.fulfilled, (state, action) => {
      state.statsNWposts = action.payload;
      state.isStatsNWPostFail = false;
      state.isStatsNWPostSuccess = true;
      state.nwpostsLoading = false;
    });

    builder.addCase(getStatsNWPosts.rejected, (state, action) => {
      state.statNWserror = readThunkError(action);
      state.isStatsNWPostFail = true;
      state.isStatsNWPostSuccess = false;
      state.nwpostsLoading = false;
    });

    //instagram
    builder.addCase(getStatsIGPosts.fulfilled, (state, action) => {
      state.statsIGposts = action.payload;
      state.isStatsIGPostFail = false;
      state.isStatsIGPostSuccess = true;
      state.igpostsLoading = false;
    });

    builder.addCase(getStatsIGPosts.rejected, (state, action) => {
      state.statIGserror = readThunkError(action);
      state.isStatsIGPostFail = true;
      state.isStatsIGPostSuccess = false;
      state.igpostsLoading = false;
    });

    //==================================[ /stats/ ]=======================================
    builder.addCase(getStatsPosts.pending, (state) => {
      state.isStatsPostLoading = true;
      state.isStatsPostSuccess = false;
      state.statserror = null;
    });
    builder.addCase(getStatsPosts.fulfilled, (state, action) => {
      state.isStatsPostLoading = false;
      state.isStatsPostSuccess = true;
      state.statsposts = action.payload;
    });
    builder.addCase(getStatsPosts.rejected, (state, action) => {
      state.isStatsPostLoading = false;
      state.isStatsPostSuccess = false;
      state.statserror = readThunkError(action);
    });
    //====================================================================================

    //report
    builder.addCase(getRPTStatsPosts.fulfilled, (state, action) => {
      state.rptstatsposts = action.payload;
      state.isRPTStatsPostFail = false;
      state.isRPTStatsPostSuccess = true;
    });

    builder.addCase(getRPTStatsPosts.rejected, (state, action) => {
      state.rptstatserror = readThunkError(action);
      state.isRPTStatsPostFail = true;
      state.isRPTStatsPostSuccess = false;
    });

    // Тайлангийн эх сурвалж бүрийн статистик.
    // ⚠️ Урьд нь платформ тус бүрд 2 case (нийт 8) + тусдаа state талбар
    // (`rptstatsFBposts`…) байсан тул шинэ платформ нэмэхэд энэ файлыг заавал
    // засах шаардлагатай байв. Одоо `source`-оор индекслэсэн нэг объект.
    builder.addCase(getRPTStatsBySource.fulfilled, (state, action) => {
      state.rptstatsBySource = {
        ...state.rptstatsBySource,
        [action.payload.source]: action.payload.data,
      };
      state.isRPTStatsBySourceFail = false;
    });

    builder.addCase(getRPTStatsBySource.rejected, (state, action) => {
      state.rptstatsBySourceError = readThunkError(action);
      state.isRPTStatsBySourceFail = true;
    });

    //report
    builder.addCase(getRPTPosts.fulfilled, (state, action) => {
      state.rptposts = action.payload;
      state.isRPTPostFail = false;
      state.isRPTPostSuccess = true;
    });

    builder.addCase(getRPTPosts.rejected, (state, action) => {
      state.rpterror = readThunkError(action);
      state.isRPTPostFail = true;
      state.isRPTPostSuccess = false;
    });

    //==================================[ /getFBPosts/ ]=================================
    builder.addCase(getFBPosts.pending, (state) => {
      state.isFBPostLoading = true;
      state.isFBPostSuccess = false;
      state.fberror = null;
    });
    builder.addCase(getFBPosts.fulfilled, (state, action) => {
      state.isFBPostLoading = false;
      state.isFBPostSuccess = true;
      state.fbposts = action.payload;
    });
    builder.addCase(getFBPosts.rejected, (state, action) => {
      state.isFBPostLoading = false;
      state.isFBPostSuccess = false;
      state.fberror = readThunkError(action);
    });
    //====================================================================================

    //==================================[ /getTWPosts/ ]=================================
    builder.addCase(getTWPosts.pending, (state) => {
      state.isTWPostLoading = true;
      state.isTWPostSuccess = false;
      state.twerror = null;
    });
    builder.addCase(getTWPosts.fulfilled, (state, action) => {
      state.isTWPostLoading = false;
      state.isTWPostSuccess = true;
      state.twposts = action.payload;
    });
    builder.addCase(getTWPosts.rejected, (state, action) => {
      state.isTWPostLoading = false;
      state.isTWPostSuccess = false;
      state.twerror = readThunkError(action);
    });
    //====================================================================================

    //==================================[ /getNWPosts/ ]=================================
    builder.addCase(getNWPosts.pending, (state) => {
      state.isNWPostLoading = true;
      state.isNWPostSuccess = false;
      state.nwerror = null;
    });
    builder.addCase(getNWPosts.fulfilled, (state, action) => {
      state.isNWPostLoading = false;
      state.isNWPostSuccess = true;
      state.nwposts = action.payload;
    });
    builder.addCase(getNWPosts.rejected, (state, action) => {
      state.isNWPostLoading = false;
      state.isNWPostSuccess = false;
      state.nwerror = readThunkError(action);
    });
    //====================================================================================

    //==================================[ /getIGPosts/ ]=================================
    builder.addCase(getIGPosts.pending, (state) => {
      state.isIGPostLoading = true;
      state.isIGPostSuccess = false;
      state.igerror = null;
    });
    builder.addCase(getIGPosts.fulfilled, (state, action) => {
      state.isIGPostLoading = false;
      state.isIGPostSuccess = true;
      state.igposts = action.payload;
    });
    builder.addCase(getIGPosts.rejected, (state, action) => {
      state.isIGPostLoading = false;
      state.isIGPostSuccess = false;
      state.igerror = readThunkError(action);
    });
    //====================================================================================

    builder.addCase(addNewPost.fulfilled, (state, action) => {
      state.posts.push(action.payload);
      state.isPostAdd = true;
      state.isPostAddFail = false;
    });

    builder.addCase(addNewPost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isPostAdd = false;
      state.isPostAddFail = true;
    });

    builder.addCase(updatePost.fulfilled, (state, action) => {
      if (action.payload && action.payload._id) {
        const id = action.payload._id.toString();
        const patch = (arr) => (arr || []).map((post) =>
          post._id.toString() === id ? { ...post, ...action.payload } : post
        );
        state.posts = patch(state.posts);
        // ⚠️ Threads/YouTube/LinkedIn-ий нийтлэл `platformPosts`-д байдаг тул
        // энд шинэчлэхгүй бол гараар өөрчилсөн хандлага дэлгэцэд буцаж хуучин
        // утгаараа харагдана.
        Object.keys(state.platformPosts || {}).forEach((p) => {
          state.platformPosts[p] = patch(state.platformPosts[p]);
        });
      }
      state.isPostUpdate = true;
      state.isPostUpdateFail = false;
    });

    builder.addCase(updatePost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isPostUpdate = false;
      state.isPostUpdateFail = true;
    });

    builder.addCase(deletePost.fulfilled, (state, action) => {
      const deletedId = (action.payload._id || action.payload.post || '').toString();
      const notDeleted = (arr) => (arr || []).filter(p => p._id.toString() !== deletedId);
      state.posts = notDeleted(state.posts);
      state.fbposts = notDeleted(state.fbposts);
      state.twposts = notDeleted(state.twposts);
      state.nwposts = notDeleted(state.nwposts);
      state.igposts = notDeleted(state.igposts);
      // ⚠️ Threads/YouTube/LinkedIn нь `platformPosts` объектод хадгалагддаг тул
      // энд цэвэрлэхгүй бол устгасан нийтлэл дэлгэц дээр үлдэж, зөвхөн хуудас
      // дахин ачаалахад алга болдог байв.
      Object.keys(state.platformPosts || {}).forEach((p) => {
        state.platformPosts[p] = notDeleted(state.platformPosts[p]);
      });
      state.isPostDelete = true;
      state.isPostDeleteFail = false;
    });

    builder.addCase(deletePost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isPostDelete = false;
      state.isPostDeleteFail = true;
    });

    //==================================[ /monthly-trend/ ]============================
    builder.addCase(getMonthlyTrend.fulfilled, (state, action) => {
      state.monthlyTrend = action.payload;
    });

    //==================================[ /wordcloud/ ]=================================
    builder.addCase(getWordCloud.pending, (state) => {
      state.isWordCloudLoading = true;
      state.isWordCloudSuccess = false;
      state.wordclouderror = null;
    });
    builder.addCase(getWordCloud.fulfilled, (state, action) => {
      state.isWordCloudLoading = false;
      state.isWordCloudSuccess = true;
      state.wordcloud = action.payload;
    });
    builder.addCase(getWordCloud.rejected, (state, action) => {
      state.isWordCloudLoading = false;
      state.isWordCloudSuccess = false;
      state.wordclouderror = readThunkError(action);
    });
  },
});

export default postSlice.reducer;
